"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCodeFromGlobalId = getCodeFromGlobalId;
exports.getShortCodeFromGlobalId = getShortCodeFromGlobalId;
exports.getStandardSetGlobalIdFromGlobalId = getStandardSetGlobalIdFromGlobalId;
exports.simplifyCode = simplifyCode;
const constants_1 = require("../constants");
function getCodeFromGlobalId(globalId) {
    return globalId.split(constants_1.STANDARD_CODE_SEPARATOR).pop();
}
function getShortCodeFromGlobalId(globalId) {
    const code = getCodeFromGlobalId(globalId);
    const standardSetGlobalId = getStandardSetGlobalIdFromGlobalId(globalId);
    const codePrefixes = constants_1.STANDARD_SET_CODE_PREFIXES[standardSetGlobalId];
    return simplifyCode(code, codePrefixes);
}
function getStandardSetGlobalIdFromGlobalId(globalId) {
    return globalId.split(constants_1.STANDARD_CODE_SEPARATOR)[0];
}
function simplifyCode(code, codePrefixes) {
    let result = code;
    if (code && codePrefixes) {
        codePrefixes.forEach((codePrefix) => {
            const split = result.split(codePrefix);
            result = split.length > 1 ? split[1] : split[0];
        });
    }
    return result;
}
//# sourceMappingURL=standard-item.helper.js.map